// extracted by mini-css-extract-plugin
export default {"input":"E49iI","input__core":"pcQhR","input--skeleton":"aOY4w"};